export const BATTERY_SPECIAL_OFFER = 7
export const GRADE_PREMIUM_VALUE = 9
